function Home() {
  return (
    <section id="home-section" class="home-section">
      <div class="home-container ">
        <div class="home-text">
          <h1>Amy Dinh</h1>
          <h4>Hello, I'm a web developer based in Minneapolis, MN</h4>
        </div>
      </div>
      <a href="#about-me-section">
        <button class="about-me-button">Get to Know Me</button>
      </a>
    </section>
  );
}

export default Home;
